import { createSlice } from "@reduxjs/toolkit";
import { AppVersion } from "../types";
import { doFetchAppVersionList, doEditAppVersion } from "./app-version.action";

interface AppVersionState {
  loadingList: boolean; // first load table loader
  refreshing: boolean; // silent refresh after edit
  data: AppVersion[];
  error: string | null;
}

const initialState: AppVersionState = {
  loadingList: false,
  refreshing: false,
  data: [],
  error: null,
};

const appVersionSlice = createSlice({
  name: "appVersion",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // --------------------------- FETCH LIST ---------------------------
      .addCase(doFetchAppVersionList.pending, (state) => {
        // Only show full loader if not refreshing
        if (!state.refreshing) {
          state.loadingList = true;
        }
        state.error = null;
      })
      .addCase(doFetchAppVersionList.fulfilled, (state, action) => {
        state.data = action.payload?.data || [];
        state.loadingList = false;
        state.refreshing = false; // reset silent refresh
      })
      .addCase(doFetchAppVersionList.rejected, (state, action) => {
        state.loadingList = false;
        state.refreshing = false;
        state.error =
          (action.error.message as string) ||
          "Failed to fetch app versions list";
      })

      // --------------------------- EDIT VERSION ---------------------------
      .addCase(doEditAppVersion.pending, (state) => {
        // Do not show full loader on edit
        state.error = null;
      })
      .addCase(doEditAppVersion.fulfilled, (state) => {
        // Enable silent refresh mode
        state.refreshing = true;
      })
      .addCase(doEditAppVersion.rejected, (state, action) => {
        state.error =
          (action.error.message as string) || "Failed to edit app version";
      });
  },
});

export default appVersionSlice.reducer;
